import type { CvVisibilityDefaults, ProfilePrivacySettings } from '@tabbio/types';
import {
  getPrivateCvVisibilityDefaults,
  getPublicProfileEffectivePrivacy,
  normalizeProfilePrivacySettings,
} from '@tabbio/utils/profile-privacy';
import type { CVProfile } from './cv-mock-data';

export function applyPublicPrivacyToCvProfile(
  profile: CVProfile,
  privacy?: ProfilePrivacySettings,
): CVProfile {
  const effectivePrivacy = getPublicProfileEffectivePrivacy(
    normalizeProfilePrivacySettings(privacy),
  );

  return {
    ...profile,
    avatarUrl: effectivePrivacy.showPhoto ? profile.avatarUrl : '',
    contactEmail: effectivePrivacy.showEmail ? profile.contactEmail : '',
    phone: effectivePrivacy.showPhone ? profile.phone : '',
    location: effectivePrivacy.showLocation ? profile.location : '',
    website: effectivePrivacy.showLinks ? profile.website : '',
    linkedin: effectivePrivacy.showLinks ? profile.linkedin : '',
    github: effectivePrivacy.showLinks ? profile.github : '',
    dribbble: effectivePrivacy.showLinks ? profile.dribbble : '',
    behance: effectivePrivacy.showLinks ? profile.behance : '',
  };
}

export function shouldUsePublicAvatarUrl(
  privacy?: ProfilePrivacySettings,
): boolean {
  return getPublicProfileEffectivePrivacy(
    normalizeProfilePrivacySettings(privacy),
  ).showPhoto;
}

export function getCvShareVisibilityDefaults(
  privacy?: ProfilePrivacySettings,
): CvVisibilityDefaults {
  return getPrivateCvVisibilityDefaults(normalizeProfilePrivacySettings(privacy));
}
